import React, { useState } from 'react';
import { Zap, Loader2, Save } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { competitorsAPI } from '../services/api';

const AutoAlignToggle = ({ productId, autoAlign, offset, minMarginPct, onSaved }) => {
  const [enabled, setEnabled] = useState(!!autoAlign);
  const [off, setOff] = useState(String(offset ?? 0.1));
  const [saving, setSaving] = useState(false);
  const dirty = enabled !== !!autoAlign || Math.abs(parseFloat(off.replace(',', '.')) - (offset ?? 0.1)) > 0.001;

  const save = async () => {
    setSaving(true);
    try {
      const r = await competitorsAPI.setAutoAlign(productId, enabled, parseFloat(off.replace(',', '.')) || 0);
      toast.success(r.auto_align ? 'Alignement automatique activé' : 'Alignement automatique désactivé');
      onSaved?.(r);
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Enregistrement impossible');
      setEnabled(!!autoAlign);
    } finally {
      setSaving(false);
    }
  };

  return (
    <section className="border rounded-lg p-4" data-testid="auto-align-section">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <label className="flex items-center gap-3 cursor-pointer">
          <input type="checkbox" checked={enabled} onChange={(e) => setEnabled(e.target.checked)} data-testid="auto-align-toggle" className="w-4 h-4 rounded border-gray-300 text-orange-500" />
          <span className="font-semibold text-gray-900 flex items-center gap-2"><Zap size={16} className="text-orange-500" /> Alignement automatique après chaque relevé</span>
        </label>
        <div className="flex items-center gap-2 text-sm">
          <span className="text-gray-600">Écart (€)</span>
          <Input type="number" step="0.01" min="0" value={off} onChange={(e) => setOff(e.target.value)} disabled={!enabled} data-testid="auto-align-offset" className="w-24 h-8" />
          <Button size="sm" onClick={save} disabled={saving || !dirty} data-testid="auto-align-save" className="bg-green-600 hover:bg-green-700">{saving ? <Loader2 size={14} className="animate-spin" /> : <Save size={14} />}</Button>
        </div>
      </div>
      <p className="text-xs text-gray-500 mt-2">
        Si un concurrent passe sous notre prix lors d'un relevé, le prix est automatiquement placé juste en dessous du moins cher, sans jamais franchir la <strong>marge HT plancher de {minMarginPct ?? 15} %</strong> (réglable dans l'en-tête de la veille). Sans prix d'achat fournisseur, l'automatisme refuse de s'activer.
      </p>
    </section>
  );
};

export default AutoAlignToggle;
